var React = require('react');

function ArrowSwirlUp32x64 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Size=32x64, Invert=off, Flip=off","clipPath":"url(#clip0_6934_26235)","stroke":"currentColor","strokeWidth":"3","strokeMiterlimit":"10","key":0},[React.createElement("path",{"id":"Vector","d":"M29.557 6.745l-9.867-4.99-1.549.566-4.106 10.07","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M18.763 2.196s13.399 28.94.504 36.872c-10.805 6.64-18.209-1.72-15.839-7.92 2.523-6.618 11.346-7.297 15.699.226 5.127 8.972 3.027 31.407 3.027 31.407","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_6934_26235"},React.createElement("path",{"fill":"#fff","d":"M0 0h32v64H0z"})))]);
}

ArrowSwirlUp32x64.defaultProps = {"width":"32","height":"64","viewBox":"0 0 32 64","fill":"none"};

module.exports = ArrowSwirlUp32x64;

ArrowSwirlUp32x64.default = ArrowSwirlUp32x64;
